import { Route } from '@angular/router';
import { CompanyUsersViewComponent } from '@app/views/company/users/company-users/company-users-view.component';

import { UsersComponent } from './users.component';

export const usersRoutes: Route[] = [
  {
    path: '',
    component: UsersComponent,
    children: [
      {
        path: '',
        component: CompanyUsersViewComponent
      }
      // {
      //   path: 'create',
      //   component: CreateCompanyUserViewComponent,
      // },
      // {
      //   path: 'edit/:user-id',
      //   component: EditCompanyUserViewComponent,
      // }
    ]
  }
];
